import { render } from "./WDataTableFooter.vue?vue&type=template&id=461d719d&ts=true"
import script from "./WDataTableFooter.vue?vue&type=script&lang=ts"
export * from "./WDataTableFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__